import { LANGUAGE } from "../../ducks/languageSelector";
import LocaleProvider from "./LocaleProvider";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
  return {
    language: state.languageSelector[LANGUAGE]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(LocaleProvider);
